import {FC, Fragment, ReactElement} from 'react';
import {useQuery} from 'react-query';
import {NotEnoughUsage} from '../components/NotEnoughUsage';
import {SpinContainer} from '../components/SpinContainer';
import {OrganisationOverview} from '../types';
import { useOrganisation } from '../layout/OrganisationInformationProvider';
import { isNumber } from 'lodash';


export const hasEnoughUsage = (
    userCount: number | null | undefined,
    minimumUserCount: number | null | undefined,
): boolean => {
    if (!isNumber(minimumUserCount)) return true;
    if (!isNumber(userCount)) return false;
    return userCount >= minimumUserCount;
};

export const useOrganisationAnalyticsAccess = () => {
    const {minimum_students_for_analytics} = useOrganisation();
    const {data, isLoading} = useQuery<OrganisationOverview>('/reports/overview');

    return {
        hasEnoughUsage: hasEnoughUsage(data?.students, minimum_students_for_analytics),
        isLoading,
    };
};

export const OrganisationAnalyticsAccess: FC = ({children}): ReactElement => {
    const {hasEnoughUsage: canAccessAnalytics, isLoading} = useOrganisationAnalyticsAccess();

    if (isLoading) {
        return <SpinContainer/>;
    }

    if (!canAccessAnalytics) {
        return <NotEnoughUsage/>;
    }

    return <Fragment>{children}</Fragment>;
};
